import type { Dashboard } from '@/types';
import { dashboardTemplates } from './templates';

function makeFromTemplate(key: string, id: string, ownerId: string): Dashboard {
  const tpl = dashboardTemplates.find((t) => t.key === key)!;
  const built = tpl.build();
  const now = new Date().toISOString();
  return {
    id,
    ownerId,
    version: 1,
    versions: [],
    createdAt: now,
    updatedAt: now,
    isShared: true,
    ...built,
  };
}

export const mockDashboards: Dashboard[] = [
  makeFromTemplate('executive', 'dash_exec', 'user_1'),
  makeFromTemplate('sales', 'dash_sales', 'user_2'),
  makeFromTemplate('operations', 'dash_ops', 'user_1'),
];
